import { Injectable, inject } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { environment } from '@rocksoft/environment';
import { Observable, of } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import { DeviceResolverActions, DeviceStoreSelectors } from '../device-store';

@Injectable({ providedIn: 'root' })
export class DeviceApplicationStateResolver implements Resolve<boolean> {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    const isAppManagementEnabled = environment.features.appmanagement.enabled;
    if (!isAppManagementEnabled) {
      return of(false);
    }

    return this.store.select(DeviceStoreSelectors.selectHasLoadedAnyInUse).pipe(
      tap((loaded) => {
        if (!loaded) {
          this.store.dispatch(DeviceResolverActions.deviceApplicationStatesRequested());
        }
      }),
      map(() => true),
      first()
    );
  }
}
